export enum SubCategory {
    TROUBLESHOOTING = "TROUBLESHOOTING",
    INTERNET_USE = "INTERNET_USE",
    ADMINISTRATIVE = "ADMINISTRATIVE",
    /*JOB_SEARCHING = "JOB_SEARCHING",*/

    SIMPLE = "SIMPLE",
    SMALL_REPAIR = "SMALL_REPAIR",
    INSTALLATION = "INSTALLATION",

    IRONING = "IRONING",
    CLEANING = "CLEANING",
    LAUNDRY = "LAUNDRY",

    BABYSITTING_DURING_WEEK = "BABYSITTING_DURING_WEEK",
    BABYSITTING_DURING_WEEKEND = "BABYSITTING_DURING_WEEKEND",

    PLANTATION = "PLANTATION",
    TERRACE = "TERRACE",
    TRIMMING = "TRIMMING",
    OUTDOOR_CLEANING = "OUTDOOR_CLEANING",

    HOMEWORK = "HOMEWORK",
    FOREIGN_LANGUAGES = "FOREIGN_LANGUAGES",
    OTHER_LESSON = "OTHER_LESSON",
}

export type AppCategoryKey =
    | "ASSISTANCE"
    | "HANDIWORK"
    | "HOUSEKEEPING"
    | "CHILDCARE"
    | "GARDENING"
    | "PRIVATE_TUTORING";

/**
 * Maps every known subcategory key (including legacy ones) to its parent category.
 * JOB_SEARCHING is kept here to support legacy payloads even though the enum value is disabled.
 */
export const SUBCATEGORY_TO_CATEGORY: Record<string, AppCategoryKey> = {
    TROUBLESHOOTING: "ASSISTANCE",
    INTERNET_USE: "ASSISTANCE",
    ADMINISTRATIVE: "ASSISTANCE",
    JOB_SEARCHING: "ASSISTANCE",

    SIMPLE: "HANDIWORK",
    SMALL_REPAIR: "HANDIWORK",
    INSTALLATION: "HANDIWORK",

    IRONING: "HOUSEKEEPING",
    CLEANING: "HOUSEKEEPING",
    LAUNDRY: "HOUSEKEEPING",

    BABYSITTING_DURING_WEEK: "CHILDCARE",
    BABYSITTING_DURING_WEEKEND: "CHILDCARE",

    PLANTATION: "GARDENING",
    TERRACE: "GARDENING",
    TRIMMING: "GARDENING",
    OUTDOOR_CLEANING: "GARDENING",

    HOMEWORK: "PRIVATE_TUTORING",
    FOREIGN_LANGUAGES: "PRIVATE_TUTORING",
    OTHER_LESSON: "PRIVATE_TUTORING",
};
